import React, { useState, useEffect } from "react";
import Button from "../../common/Button/Button";

const MakeAnImpact = () => {
  const [showLightbox, setShowLightbox] = useState(false);

  const handleLightboxToggle = () => {
    setShowLightbox(!showLightbox);
  };

  useEffect(() => {
    if (showLightbox) {
      document.body.classList.add('lightbox-open');
    } else {
      document.body.classList.remove('lightbox-open');
    }
    
    return () => {
      document.body.classList.remove('lightbox-open');
    };
  }, [showLightbox]);

  return (
    <div className="makeAnImpact" data-aos="fade-up">
      <h1 data-aos="zoom-in" data-aos-delay="100">
        Make an Impact!<br />
        Donate Now
      </h1>
      <div className="donateSection">
        <p data-aos="fade-up" data-aos-delay="200">
          Thanks to the generosity of our regular members and donors, we have raised over $150,000 since 2020. 
          Contributions of any size make a meaningful difference, significantly improving the schools and lives 
          of the communities that greatly need our help. Every dollar goes directly to supporting education 
          and empowering the youth of Afghanistan.
        </p>
        <div className="hero-btns">
          <div className="hero-btn-group" data-aos="fade-up" data-aos-delay="300">
            <Button
              className="btns"
              buttonStyle="btn--solid"
              buttonSize="btn--large"
              onClick={handleLightboxToggle}
            >
              DONATE (US)
            </Button>
            <Button
              className="btns"
              buttonStyle="btn--solid"
              buttonSize="btn--large"
              src="https://www.paypal.com/paypalme/atiqrahin"
              newTab="true"
            >
              DONATE (INTERNATIONAL)
            </Button>
          </div>
        </div>
      </div>

      {/* Lightbox Popup */}
      {showLightbox && (
        <div className="lightbox" onClick={handleLightboxToggle}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-button"
              onClick={handleLightboxToggle}
              aria-label="Close"
            >
              ×
            </button>
            <h2>US Payment Options</h2>
            <p><strong>Zelle:</strong> 609-540-3266</p>
            <p><strong>Venmo:</strong> @Atiq-Rahin</p>
            <p><strong>PayPal:</strong> @AtiqRahin</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MakeAnImpact;